import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelLista = ({elementoI, handleClickidListaI, idListaI}) => {
  return(
    <tr className='' onClick={(ev)=>handleClickidListaI(ev, elementoI)}>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.cantidadCoti}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrProducto}</td>
    </tr>
  )
};
const Lista = ({listI, handleClickidListaI, idListaI}) => {
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} handleClickidListaI={handleClickidListaI} 
        key={i} idListaI={idListaI}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class VerCotizacionPro2 extends React.Component {
  state={
    argsDocum: {
      estadoCoti: this.props.idLista.estadoCoti,
      numCoti: this.props.idLista.numCoti,
      descrEmpresa: this.props.idLista.descrEmpresa?this.props.idLista.descrEmpresa:"",
      titulo: this.props.idLista.titulo?this.props.idLista.titulo:"", 
      descrPolitica: this.props.idLista.descrPolitica?this.props.idLista.descrPolitica:"",
      titulo2: this.props.idLista.titulo2?this.props.idLista.titulo2:"", 
      parrafo2: this.props.idLista.parrafo2?this.props.idLista.parrafo2:"", 
      titulo3: this.props.idLista.titulo3?this.props.idLista.titulo3:"", 
      parrafo3: this.props.idLista.parrafo3?this.props.idLista.parrafo3:"", 
      ciudadFechaEnvio: this.props.idLista.ciudadFechaEnvio?this.props.idLista.ciudadFechaEnvio:"",
      nombreContacto: this.props.idLista.nombreContacto?this.props.idLista.nombreContacto:"",
      ciudadContacto: this.props.idLista.ciudadContacto?this.props.idLista.ciudadContacto:"",
      cargoContacto: this.props.idLista.cargoContacto?this.props.idLista.cargoContacto:"",
      mailContacto: this.props.idLista.mailContacto?this.props.idLista.mailContacto:"",
      telContacto: this.props.idLista.telContacto?this.props.idLista.telContacto:"",
      referencia: this.props.idLista.referencia?this.props.idLista.referencia:"",
      tiempoEntrega: this.props.idLista.tiempoEntrega?this.props.idLista.tiempoEntrega:"",
      lugarEntrega: this.props.idLista.lugarEntrega?this.props.idLista.lugarEntrega:"",
      formaPago: this.props.idLista.formaPago?this.props.idLista.formaPago:"",
      validezOferta: this.props.idLista.validezOferta?this.props.idLista.validezOferta:"",
      observaciones: this.props.idLista.observaciones?this.props.idLista.observaciones:"",
      cedula: this.props.idLista.cedula?this.props.idLista.cedula:"",
      nombreUsuario: this.props.idLista.nombreUsuario?this.props.idLista.nombreUsuario:"",
      tipo: this.props.idLista.tipo,
      fechaCreate: this.props.idLista.fechaCreate,
      fechaAut: this.props.idLista.fechaAut?this.props.idLista.fechaAut:"",
      usuarioAut: this.props.idLista.usuarioAut?this.props.idLista.usuarioAut:"",
      observacionesAut: this.props.idLista.observacionesAut?this.props.idLista.observacionesAut:"",
      _id: this.props.idLista._id
    },
    confirmaAct: false, descrProductoI: "", permiteBtn1: true, procBtn: 0, checked: false, 
    open: false
  }

  handleChange = (ev, argsDocum) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name==="aprobarCoti"){
        this.setState({checked: ev.target.checked})
      }else{      
        argsDocum[ev.target.name] = ev.target.value
      }
      this.setState({argsDocum});
    }
  }

  handleClickidListaI = async (ev, idLista, productoI)=>{
    ev.preventDefault()
    this.setState({descrProductoI: productoI})
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
      // }
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  handleElimItem = async (ev, descrProductoI, idCoti)=>{
    if(descrProductoI){
      const argsUpd = {
        descrProducto: descrProductoI,
        _id: idCoti
      }
      argsUpd.tipoAct = "EliminarItem"
      await this.props.editCotizacion({variables: argsUpd});
    }else{
      alert("!! Por favor seleccione el item a eliminar !!")
    }
  }

  render (){
    const {checked, argsDocum, confirmaAct, open, productoI, permiteBtn1} = this.state;
    if(checked===true){
      argsDocum.estadoCoti = "Aprobada"
    }else{
      argsDocum.estadoCoti = "Creada"
    }

    const a356505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "356505" );

    let mensaje1 = "Eliminar item de la solicitud "
    if(this.props.productoI){
      mensaje1 = `Eliminar ${this.props.productoI} de la solicitud ${argsDocum.numCoti}`
    }else{
      mensaje1 += "(Seleccionar...)"
    }
    let imgIcon1 = "images/archivo_32.png"
    let idCoti = this.props.idLista._id

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Solicitudes de compra
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            (ev)=>this.props.handleSubmit(ev, argsDocum):
            permiteBtn1?
            (ev)=>this.handleElimItem(ev, this.props.productoI, idCoti):
            ()=>{}}>
            <div className="row container">
              <div className="column" width="100%">  
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <Form.Input autoComplete="off" name="observaciones" id="observaciones" value={argsDocum.observaciones} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
            </div>
            {a356505!==-1 &&
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '3%'}}>
                    <Form.Field>
                        <div className="column">
                          <input type='checkbox' id="aprobarCoti" name="aprobarCoti" style={this.props.styles.input} checked={checked} onChange={this.handleChange}/>
                        </div>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '17%'}}>
                    <Form.Field>
                      <div className="column">
                        <p style={{color: '#302b63', fontSize: '1.0em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                          &nbsp;&nbsp;APROBAR SOLICITUD DE COMPRA
                        </p> 
                      </div>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '80%'}}>  
                    <Form.Field>
                      <label style={this.props.styles.label}>Observaciones para aprobación</label>
                      <Form.Input autoComplete="off" name="observacionesAut" id="observacionesAut" value={argsDocum.observacionesAut} onChange={this.handleChange} placeholder='Observaciones de aprobación' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionesAut'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field> 
                  </div>
                </div>
              </div> 
            }
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
              
              <div style={{height: '10em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Material</th>
                    </tr>
                  </thead>
                  <Lista listI={this.props.list4} handleClickidListaI={this.props.handleClickidListaI} productoI={productoI}/>
                </table>
                <p></p>
              </div>
              <div className="column" style={{width: '100%', paddingTop: '0.3em'}}>
                <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                  open={open}
                  styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
              </div>
          </Form>
        </div>
      </div>
    )
  }
}

// export default VerCotizacion2
export default compose(
  graphql(queries.query.allMaterial, {name:'allMaterial'}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Solicitud'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),


)(VerCotizacionPro2)
